import { render, staticRenderFns } from "./PostDiceNav.vue?vue&type=template&id=8f3c9208&scoped=true&"
import script from "./PostDiceNav.vue?vue&type=script&lang=js&"
export * from "./PostDiceNav.vue?vue&type=script&lang=js&"
import style0 from "./PostDiceNav.vue?vue&type=style&index=0&id=8f3c9208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3c9208",
  null
  
)

export default component.exports